import React, {useState} from 'react';
import {t} from '@lingui/core/macro';

import BurgerMenu from 'shared/ui/icons/NavMenu/BurgerMenu';
import {CloseButton} from 'shared/ui/IconButton/iconButtons';

import Navigation from '../Navigation/Navigation';

import styles from './NavigationToggle.module.scss';

const NavigationToggle: React.FC = () => {
    const [opened, setOpened] = useState(false);

    const toggleMenu = React.useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        setOpened(prev => !prev);
    }, []);

    return (
        <>
            <a className={styles.toggle}
                href="components/Layout/MainLayout/NavigationToggler/NavigationToggle#"
                onClick={toggleMenu}
            >
                {
                    opened
                        ? <CloseButton className={styles.button} title={t`Закрыть`} iconSize={24}/>
                        : <BurgerMenu/>
                }
            </a>

            <Navigation opened={opened}/>
        </>
    );
};

export default NavigationToggle;